export default {
    /* Earn Actions tile — "Completed" badge */
    badgeContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    rewardTileCompletedBadge: {
        flex: '0 0 auto',
        textStyle: 'badge',
        padding: '7px 8px',
        color: 'webTypo.textPrimaryReverse',
        backgroundColor: 'webTypo.textPrimary',
        marginTop: '8px'
    }
}
